import { z } from "zod/v4";

export const ReadmeWebhookRequestBodySchema = z.object({
  email: z.string(),
});
export type ReadmeWebhookRequestBodyType = z.infer<
  typeof ReadmeWebhookRequestBodySchema
>;
